// Génère un UUID v4 (RFC 4122) en s'appuyant sur crypto.getRandomValues
// fourni par le polyfill react-native-get-random-values (importé dans index.ts).
//
// Utilisé pour les en-têtes `Idempotency-Key` exigés par certains endpoints
// (POST /wallet/topup, POST /wallet/block, POST /wallet/capture, POST /wallet/release,
//  POST /ledger/transactions/transfer).

export function generateIdempotencyKey(): string {
  if (!globalThis.crypto?.getRandomValues) {
    throw new Error(
      "[idempotency] crypto.getRandomValues indisponible — vérifier que 'react-native-get-random-values' est bien importé en tout premier dans index.ts",
    );
  }

  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);

  // RFC 4122 §4.4 — fixer la version (4) et la variant (10xx)
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes).map((b) => b.toString(16).padStart(2, "0"));
  return (
    hex.slice(0, 4).join("") +
    "-" +
    hex.slice(4, 6).join("") +
    "-" +
    hex.slice(6, 8).join("") +
    "-" +
    hex.slice(8, 10).join("") +
    "-" +
    hex.slice(10, 16).join("")
  );
}
